import React from 'react';

export default function CustomReviewTopContent() {
  return (
    <h3 className="vads-u-font-size--h3 vads-u-margin-top--0 vads-u-margin-bottom--3">
      Review your form
    </h3>
  );
}
